document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('.button-checkout'); // チェックアウトボタンを選択
  checkoutButton.addEventListener('click', function(event) {
    const consentCheckboxes = document.querySelectorAll('.consent-chk'); // 同意のチェックボックスをすべて選択
    const allChecked = Array.from(consentCheckboxes).every(checkbox => checkbox.checked);

    if (!allChecked) {
      event.preventDefault(); // チェックアウトを防止
      alert('購入を続ける前に、すべての項目に同意してください。');
    }
  });
});
